module.exports = __webpack_public_path__ + "static/media/5.1.6e6415b7.zip";